<div class="alert-checkin">
  <div>
    <img width="30px" height="30px" [src]="imgWarning" alt="warning">
  </div>
  <div style="align-self: center;">
    <span class="alert-checkin-txt">{{textWarning | translate | capitalize }}</span>
  </div>
</div>
